import { connect } from 'react-redux';
import { openPanel, closePanel, closeNextPanel } from '../../../../shared/actions/sidebar';
import Panel from './panel';

const mapDispatchToProps = dispatch => ({
  openPanel: (...args) => dispatch(openPanel(...args)),
  closePanel: (...args) => dispatch(closePanel(...args)),
  closeNextPanel: (...args) => dispatch(closeNextPanel(...args)),
});

export default connect(null, mapDispatchToProps)(Panel);
